module.exports = __webpack_public_path__ + "img/assembly-logo.8b446dbd.png";